import { Routes, Route } from "react-router-dom";
import HomePage from "./screen/HomePage";
import Achievers from "./screen/Achievers";
import Layout from "./Layout/Layout";
import { Toaster } from "react-hot-toast";

import "flag-icons/css/flag-icons.min.css";
import BookATable from "screen/BookATable";
import Menu from "./screen/Menu";
import CartMenu from "./screen/CartMenu";
import AuthModal from "components/AuthModal/AuthModal";
import SessionExpiredModal from "./components/SectionExpiredModal/SectionExpiredModal";
import ProtectedRoute from "components/ProtectedRoute/ProtectedRoute";
import About from "screen/About";
import NotFound from "screen/NotFound";
import Service from "screen/Service";
import Consulting from "screen/Consulting";
import Training from "screen/Training";
import Contact from "screen/Contact";
// import WorkshopDetail from "./screen/WorkshopDetail";
import Industry from "screen/Industry";
import TrainingBusiness from "screen/TrainingBusiness";
import PropertyAdvisory from "screen/PropertyAdvisory";
import BusinessAdvisory from "screen/BusinessAdvisory";
import BusinessConsulting from "screen/BusinessConsulting";
import Network from "screen/Network";
import ContactFormPage from "components/Contact/ContactFormPage";
import { Insight } from "screen/Insight";
import ClientsandPartner from "screen/ClientsandPartner";
import Events from "screen/Events";
import FullContactForm from "components/Contact/FullContactForm";

function App() {
  return (
    <>
      <Toaster position="bottom-left" />
      <AuthModal />
      <SessionExpiredModal />

      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<HomePage />} />

          <Route path="/bookatable" element={<BookATable />} />
          <Route
            path="/menu"
            element={
              // <ProtectedRoute>
              <Menu />
              // </ProtectedRoute>
            }
          />
          <Route path="/cart" element={<CartMenu />} />

          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Service />} />
          <Route
            path="/services/business-consulting"
            element={<BusinessConsulting />}
          />
          <Route
            path="/services/business-investment"
            element={<BusinessAdvisory />}
          />
          <Route
            path="/services/property-investment"
            element={<PropertyAdvisory />}
          />
          <Route
            path="/services/training-coaching"
            element={<TrainingBusiness />}
          />
          <Route
            path="/services/leadership-development"
            element={<Consulting />}
          />
          <Route path="/services/coach-training" element={<Training />} />
          <Route path="/networks" element={<Network />} />

          <Route path="/contact" element={<Contact />} />
          <Route path="/contact/full-form" element={<FullContactForm />} />

          <Route path="/contact/form" element={<ContactFormPage />} />
          <Route path="/events" element={<Events />} />
          <Route path="/insights" element={<Insight />} />
          <Route path="/community" element={<ClientsandPartner />} />

          {/* 🔥 MUST BE LAST */}
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
